export * from './berichts-vorlage-gespeichert.interface';
